import { CreateResumeDto, ResumeDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";
import { trackEvent } from "@/client/utils/analytics";

const dl_id = sessionStorage.getItem('token');
export const createResume = async (data: any) => {
  let dl_data:any=dl_id
  // dl_data = [data,...dl_data]
  // console.log(dl_data)
  data['token'] = dl_data
  const userId = useAuthStore.getState().user?.id;
  try {
    const response = await axios.post<ResumeDto, AxiosResponse<ResumeDto>, CreateResumeDto>(
      "/resume",
      data,
    );
    trackEvent({
      userType: "youth",
      apiName: "createResume",
      userId,
      success: true,
      resourceId: response.data.id,
    });
    return response.data;
  } catch (error) {
    trackEvent({ userType: "youth", apiName: "createResume", userId, success: false });
    throw error;
  }
};

export const useCreateResume = () => {
  
  // alert(dl_id)
  const {
    error,
    isPending: loading,
    mutateAsync: createResumeFn,
  } = useMutation({
    mutationFn: createResume,
    onSuccess: (data) => {
      queryClient.setQueryData<ResumeDto>(["resume", { id: data.id }], data);

      queryClient.setQueryData<ResumeDto[]>(["resumes"], (cache) => {
        if (!cache) return [data];
        return [...cache, data];
      });
    },
  });

  return { createResume: createResumeFn, loading, error };
};
